import React, {useState} from "react";
import {Button, Form, Input, Modal, Select, InputNumber, message} from "antd";
import { DownloadOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';
import {getHostAddress,getFileAddress} from "../../Tool/UtileFun";

export function TabButton(props){

    const [modalStatus,setModalStatus] = useState(false);

    const handleCancel = e => {
        setModalStatus(false)
    };

    const handleOk = e => {
        setModalStatus(false)
        updateStep()
    };

    const showModal = e => {
        setModalStatus(true)
    };

    let score
    const  onChange=value=> {
        score = value
        console.log('changed', value);
    }

    const updateStep = () =>{
        if (score === null || score === undefined){
            return
        }
        if (props.props.id === "" || props.props.id === null || props.props.id === undefined){
            return
        }
        let value = {
            id:props.props.id,
            score:score,
            status:"yes",
        }
        updateTask(value)
        setTimeout(function () {
            //内容3秒后执行
            props.Event()
        }, 300);
    }

    const updateTask=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/updateTask",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //setTask(data)
            })
            .catch(error => message.error("error"+error));
    }

    const from = (
        <Form>
            <Form.Item label="得分"
                       name="score"
            >
                <InputNumber min={0} max={100} defaultValue={0} onChange={onChange} />,
            </Form.Item>
        </Form>
    )

    return(
        <>
            <Modal
                title="打分"
                visible={modalStatus}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={"确定"}
                cancelText={"取消"}
            >
                {from}
            </Modal>
            <Button type={"dashed"} onClick={showModal}>打分</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="dashed" target="view_window" href={"http://"+getFileAddress()+props.props.relativeAddress} shape="circle" icon={<DownloadOutlined />} size={"large"} />&nbsp;
        </>
    )
}
